'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".TextLink-module_textLink__cMa5a{border:0;color:#2b7cac;font-size:.875rem;line-height:1.25rem;padding:0}.TextLink-module_textLink__cMa5a,.TextLink-module_textLink__cMa5a:hover{background:transparent;-webkit-text-decoration:underline;text-decoration:underline}.TextLink-module_textLink__cMa5a:hover{color:\"inherit\";cursor:pointer}";
var styles = {"textLink":"TextLink-module_textLink__cMa5a"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
